import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { GlobalSettingsValueRecognitionDialogComponent } from './components/global-settings-value-recognition-dialog/global-settings-value-recognition-dialog.component';
import {
  BusinessUnitDAEngineerClient,
  DADeliverableTemplateDAEngineerClient,
  ExceptionsClient,
  GlobalAdminsClient,
  GlobalSettingsDAEngineerClient,
  MandatoryCheckTemplateDAEngineerClient,
  ProjectPhaseTemplateDAEngineerClient,
  RiskAssessmentConfigDAEngineerClient,
  SMEDisciplineDAEngineerClient,
} from 'src/app/shared/models/autogenerated';
import { GlobalSettingsDAEngineerReducerWithForm } from './store/global-settings.reducer';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { GlobalSettingsDAEngineerEffects } from './store/global-settings.effects';
import { CommonDAEngineerModule } from '../common/common.module';
import { MandatoryChecksTemplatesComponent } from './pages/mandatory-checks-templates/mandatory-checks-templates.component';
import { GlobalSettingsDAEngineerRoutingModule } from './global-settings-routing.module';
import { MandatoryChecksTemplatesTableComponent } from './components/mandatory-checks-templates-table/mandatory-checks-templates-table.component';
import { AgGridModule } from 'ag-grid-angular';
import { AgGridConfigModule } from 'src/app/shared/ag-grid-config/ag-grid-config.module';
import { MandatoryChecksTemplatesTableActionsRendererComponent } from './components/mandatory-checks-templates-actions-renderer/mandatory-checks-templates-actions-renderer.component';
import { MandatoryCheckTemplateDialogFormComponent } from './components/mandatory-check-template-form-dialog/mandatory-check-template-form-dialog.component';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgrxFormsModule } from 'ngrx-forms';
import { GlobalAdminAccessDialogComponent } from './components/global-admin-access-dialog/global-admin-access-dialog.component';
import { PeerPoolDisciplinesComponent } from './pages/peer-pool-disciplines/peer-pool-disciplines.component';
import { PeerPoolDisciplinesTableComponent } from './components/peer-pool-disciplines-table/peer-pool-disciplines-table.component';
import { PeerPoolDisciplinesTableActionsRendererComponent } from './components/peer-pool-disciplines-actions-renderer/peer-pool-disciplines-actions-renderer.component';
import { PeerPoolDisciplineDetailsDialogComponent } from './components/peer-pool-discipline-details-dialog/peer-pool-discipline-details-dialog.component';
import { ExceptionAccessDialogComponent } from './components/exception-access-dialog/exception-access-dialog.component';
import { DeliverableTemplatesComponent } from './pages/deliverable-templates/deliverable-templates.component';
import { DeliverableTemplatesTableComponent } from './components/deliverable-templates-table/deliverable-templates-table.component';
import { DeliverableTemplateFormDialogComponent } from './components/deliverable-template-form-dialog/deliverable-template-form-dialog.component';
import { MatCheckbox } from '@angular/material/checkbox';
import { DeliverableTemplatesTableActionsRendererComponent } from './components/deliverable-templates-table-actions-renderer/deliverable-templates-table-actions-renderer.component';
import { BusinessUnitsComponent } from './pages/business-units/business-units.component';
import { BusinessUnitsTableComponent } from './components/business-units-table/business-units-table.component';
import { BusinessUnitsTableActionsRendererComponent } from './components/business-units-actions-renderer/business-units-actions-renderer.component';
import { BusinessUnitDialogFormComponent } from './components/business-unit-form-dialog/business-unit-form-dialog.component';
import { AssignmentsContactsTableComponent } from './components/assignments-contacts-table/assignments-contacts-table.component';
import { AssignmentsPhasesTableComponent } from './components/assignments-phases-table/assignments-phases-table.component';
import { AssignmentsDashboardComponent } from './pages/assignments-dashboard/assignments-dashboard.component';
import { AssignmentsMappingRendererComponent } from './components/assignments-mapping-renderer/assignments-mapping-renderer.component';
import { RiskAssessmentConfigFormDialogComponent } from './components/risk-assessment-config-form-dialog/risk-assessment-config-form-dialog.component';
import { RiskAssessmentConfigTableActionsRendererComponent } from './components/risk-assessment-config-table-actions-renderer/risk-assessment-config-table-actions-renderer.component';
import { RiskAssessmentConfigsTableComponent } from './components/risk-assessment-config-table/risk-assessment-config-table.component';
import { RiskAssessmentConfigComponent } from './pages/risk-assessment-configs/risk-assessment-configs.component';

@NgModule({
  declarations: [
    GlobalSettingsValueRecognitionDialogComponent,
    GlobalAdminAccessDialogComponent,
    ExceptionAccessDialogComponent,
    MandatoryChecksTemplatesComponent,
    MandatoryChecksTemplatesTableComponent,
    MandatoryChecksTemplatesTableActionsRendererComponent,
    MandatoryCheckTemplateDialogFormComponent,
    BusinessUnitsComponent,
    BusinessUnitsTableComponent,
    BusinessUnitsTableActionsRendererComponent,
    BusinessUnitDialogFormComponent,
    PeerPoolDisciplinesComponent,
    PeerPoolDisciplinesTableComponent,
    PeerPoolDisciplinesTableActionsRendererComponent,
    PeerPoolDisciplineDetailsDialogComponent,
    DeliverableTemplatesComponent,
    DeliverableTemplateFormDialogComponent,
    DeliverableTemplatesTableComponent,
    DeliverableTemplatesTableActionsRendererComponent,
    RiskAssessmentConfigComponent,
    RiskAssessmentConfigFormDialogComponent,
    RiskAssessmentConfigsTableComponent,
    RiskAssessmentConfigTableActionsRendererComponent,
    AssignmentsDashboardComponent,
    AssignmentsContactsTableComponent,
    AssignmentsPhasesTableComponent,
    AssignmentsMappingRendererComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    GlobalSettingsDAEngineerRoutingModule,
    MatIconModule,
    MatTooltipModule,
    MatSelectModule,
    MatDialogModule,
    FormsModule,
    NgrxFormsModule,
    AgGridModule,
    AgGridConfigModule,
    StoreModule.forFeature(
      'global-settings-da-engineer',
      GlobalSettingsDAEngineerReducerWithForm
    ),
    EffectsModule.forFeature([GlobalSettingsDAEngineerEffects]),
    CommonDAEngineerModule,
    MatCheckbox,
  ],
  providers: [
    GlobalSettingsDAEngineerClient,
    MandatoryCheckTemplateDAEngineerClient,
    BusinessUnitDAEngineerClient,
    DADeliverableTemplateDAEngineerClient,
    GlobalAdminsClient,
    ExceptionsClient,
    ProjectPhaseTemplateDAEngineerClient,
    SMEDisciplineDAEngineerClient,
    RiskAssessmentConfigDAEngineerClient,
  ],
})
export class GlobalSettingsDAEngineerModule {}
